import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { environment } from "../../../../../environments/environment";
import { getMagicCardRoute } from "@ponder-features/magic/card/magicCardRouter";
import { Subscription } from "rxjs";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { ItemSizeService } from "@ponder-shared/previewItem/item-size.service";

@Component({
    selector: "magic-hand-item",
    imports: [],
    templateUrl: "./magic-hand-item.component.html"
})
export class MagicHandItemComponent implements AfterViewInit  {
    @Input({ required: true }) public deckCard!: DeckCard;
    @ViewChild("previewImageContainer") previewImageContainerRef!: ElementRef<HTMLImageElement>;

    public cardUrl!: string;
    public cardImageUrl!: string;

    private resizeEventSub!: Subscription;

    public constructor(private events: EventBroker, private itemSize: ItemSizeService) {
        this.resizeEventSub = this.events.ui.windowResizeEvent.subscribe({
            next: () => {
                this.onResize();
            }
        });
    }

    public ngOnDestroy(): void {
        this.resizeEventSub.unsubscribe();
    }

    public ngOnInit(): void {
        this.refreshCardUrls();
    }

    public ngOnChanges(): void {
        this.refreshCardUrls();
    }

    private refreshCardUrls(): void {
        this.cardUrl = getMagicCardRoute(this.deckCard.card.item.data!.magic!);
        this.cardImageUrl = `${environment.ponderImageBaseUrl}/card/medium/front/${this.deckCard.card.item!.id!}.jpg`;
    }

    public ngAfterViewInit(): void {
        this.onResize();
    }

    public onResize(): void {
        this.previewImageContainerRef.nativeElement.style.setProperty("width", `${this.itemSize.width * 0.9 + 7}px`);
        this.previewImageContainerRef.nativeElement.style.setProperty("height", `${this.itemSize.height * 0.9 + 10}px`);
    }
}